import { type SubmitEvent as ReactSubmitEvent, memo, useState } from "react";
import AuthCard from "Components/Global/AuthCard";
import "Components/NewPasswordPage/NewPasswordPage.less";
import { Button, ButtonTypes, Input } from "@clintonelec/react-storybook";
import PasswordValidation from "Components/NewPasswordPage/PasswordValidation";
import { useAppDispatch } from "Data/Redux/Store";
import { setNeedsPasswordAction } from "Data/Redux/Slices/UserSettings";

const newPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,16}$/;

type NewPasswordForm = HTMLFormElement & {
	username: HTMLInputElement;
	password: HTMLInputElement;
	confirmPassword: HTMLInputElement;
};

function NewPassword() {
	const dispatch = useAppDispatch();
	const [ password, setPassword ] = useState("");
	const [ submitted, setSubmitted ] = useState(false);
	const setNeedsPassword = () => dispatch(setNeedsPasswordAction(false));
	const handlePasswordUpdate = (newPassword: string) => setPassword(newPassword);

	const handleFormSubmit = (event: ReactSubmitEvent<NewPasswordForm>) => {
		event.preventDefault();
		setSubmitted(true);

		if (event.currentTarget.checkValidity()) {
			// TODO: Send form data to camera
			setSubmitted(false);
			setPassword("");
			setNeedsPassword();
		}
	};

	const validateConfirmPassword = (confirmPassword?: string | number | readonly string[]) => {
		return typeof confirmPassword === "string" && confirmPassword === password;
	};

	return (
		<div className="new-password-page">
			<AuthCard onSubmit={ handleFormSubmit }>
				<h4>New Password Required!</h4>
				<label>User ID</label>
				<Input defaultValue="admin" disabled name="username" />
				<label>New Password</label>
				<Input
					name="password"
					required
					password
					noValidate={ !submitted }
					onUpdate={ handlePasswordUpdate }
					validator={ newPasswordRegex }
					validityMessage="Password must meet the requirements"
					value={ password }
				/>
				<label>Confirm Password</label>
				<Input
					name="confirmPassword"
					required
					password
					noValidate={ !submitted }
					validityMessage="Passwords must match"
					validator={ validateConfirmPassword }
				/>
				<PasswordValidation password={ password } />
				<Button
					className="login-button"
					type={ ButtonTypes.PRIMARY }
					htmlType="submit"
				>
					Submit
				</Button>
			</AuthCard>
		</div>
	);
}

export default memo(NewPassword);
